/*
 * @Author: your name
 * @Date: 2022-01-05 12:34:31
 * @LastEditTime: 2022-04-02 16:09:50
 * @LastEditors: Please set LastEditors
 * @Description: 根据打包环境分配路由
 * @FilePath: \management-admin\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/views/layout/App.vue";
import Common from "./common.js";
import Dashboard from "./dashboard.js";
import Position from "./position.js";
import ArticleManage from "./articleManage.js";
import ProductionRouter from "./productionRouter.js";
import auth from "@/router/auth";

Vue.use(VueRouter);

export let contentRoute = [];
console.log(process.env.NODE_ENV);
console.log(process.env.VUE_APP_MODE);
if (process.env.NODE_ENV === "development") {
  contentRoute = [
    ...Dashboard,
    ...ArticleManage,
    ...Position,
    ...auth
    // ...ProductionRouter
  ];
} else {
  //production
  contentRoute = [...ProductionRouter, ...auth];
}
console.log(contentRoute);
const routes = [
  {
    path: "/",
    component: Layout,
    name: `/${contentRoute[0].name}`,
    redirect: `/${contentRoute[0].path}`,
    meta: {
      title: `/${contentRoute[0].meta.title}`
    },
    children: contentRoute
  },
  Common
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  routes
});

export default router;
